import React from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'

const QuickLink = ({ icon, title, description, link, href, newTab }) => {
    return (
        <div className="lg:w-60 w-90 h-43 border border-grayLines p-8 gap-4 rounded-2xl flex flex-col items-center justify-start">
            <div className="w-12 h-12 min-h-12 rounded-full border border-grayLines bg-pageBackground flex items-center justify-center">
                {icon}
            </div>

            <div className="w-full flex flex-col items-center justify-start gap-y-2">
                <p className="text-black90 font-medium text-base leading-5">
                    {title}
                </p>
                <div className="flex flex-row items-center justify-center gap-x-1">
                    <p className="text-black30 font-normal text-sm min-w-max leading-4">
                        {description}
                    </p>
                    <a
                        className="text-links hover:underline text-sm font-normal min-w-max leading-4"
                        href={href}
                        target={clsx(newTab ? '_blank' : '')}
                        rel={clsx(newTab ? 'noopener noreferrer' : '')}
                    >
                        {link}
                    </a>
                </div>
            </div>
        </div>
    )
}

QuickLink.propTypes = {
    icon: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.any,
        PropTypes.object,
    ]),
    title: PropTypes.string,
    description: PropTypes.string,
    link: PropTypes.string,
    href: PropTypes.string,
    newTab: PropTypes.bool,
}

export default QuickLink
